import React from 'react';
import PropTypes from 'prop-types';
import { useLitePicker } from '@/shared/ui/components/date-picker/useLitePicker';
import Input from '@/shared/ui/elements/input/Input';
import Label from '@/shared/ui/elements/label/Label';
import { getModifiers, label as labelHelper } from '@/shared/ui/core';
import { InputWrapper } from './Date.styled';
import IconCalendar from '@/shared/assets/icons/icon-calendar-outline.svg';

export default ({ name, outLabel, label, litePickerProps, ...props }) => {
  const register = useLitePicker(name, litePickerProps);
  React.useEffect(register, []);

  const labelModifiers = ['default', 'required'];

  return (
    <>
      {outLabel && (
        <Label
          content={outLabel}
          modifiers={getModifiers(props, labelModifiers)}
        />
      )}
      <InputWrapper>
        <Input
          name={name}
          autoComplete="off"
          {...labelHelper(label)}
          {...props}
        />
        <IconCalendar />
      </InputWrapper>
    </>
  );
};

Date.propTypes = {
  name: PropTypes.string.isRequired,
  outLabel: PropTypes.string,
  label: PropTypes.string,
  litePickerProps: PropTypes.shape({}),
};

Date.defaultProps = {
  outLabel: '',
  label: '',
  litePickerProps: {},
};
